import Rest from '@/services/Rest';

/**
 * @typedef {BitrixService}
 */
export default class BitrixService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/bitrix'
}
